type KebabCase = `${Lowercase<string>}-${Lowercase<string>}`;

type FeatureFlagKey = `${number}-${KebabCase}`;

type FeatureFlags = {
  [K in FeatureFlagKey]?: boolean;
};

export const featureFlags: FeatureFlags = {
  "13963-master-payment-types": true,
} as const;

export type FeatureFlag = keyof typeof featureFlags;
